import { useScanDeviceApiUpsert } from '@hooks/api/useScanDeviceApiUpsert';
import type { VrsType, VrsTypeUpsertInput } from 'types/api';

export const useVrsTypeUpsert = useScanDeviceApiUpsert<VrsType, VrsTypeUpsertInput>('/vrs-types');
